const API_BASE_URL = (
  process.env.REACT_APP_MERCHANT_API_BASE_URL ||
  "http://secondbite-manage.localhost/merchant-api/v1"
).replace(/\/+$/, "");

const TOKEN_KEY = "vendor_token";
const STAFF_KEY = "merchant_staff";
const CODE_KEY = "merchant_login_code";

const readPayload = async (response) => response.json().catch(() => null);

export const loginMerchant = async ({ merchantCode, phone, password }) => {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({
        merchant_code: merchantCode.trim().toUpperCase(),
        phone: String(phone).replace(/\D/g, ""),
        password,
      }),
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  const payload = await readPayload(response);
  if (!response.ok || !payload?.success) {
    const validationMessage = payload?.errors
      ? Object.values(payload.errors).flat()[0]
      : null;
    throw new Error(validationMessage || payload?.message || "Login failed.");
  }

  localStorage.setItem(TOKEN_KEY, payload.data.token);
  localStorage.setItem(STAFF_KEY, JSON.stringify(payload.data.staff));
  localStorage.setItem(CODE_KEY, payload.data.staff?.merchant?.code || merchantCode.trim().toUpperCase());
  return payload.data;
};

export const logoutMerchant = async () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    await fetch(`${API_BASE_URL}/auth/logout`, {
      method: "POST",
      headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
    }).catch(() => null);
  }
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(STAFF_KEY);
  localStorage.removeItem(CODE_KEY);
};

export const refreshMerchantProfile = async () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return null;

  const response = await fetch(`${API_BASE_URL}/auth/me`, {
    headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
  }).catch(() => null);
  if (!response?.ok) return null;

  const payload = await readPayload(response);
  if (!payload?.success || !payload.data) return null;
  localStorage.setItem(STAFF_KEY, JSON.stringify(payload.data));
  window.dispatchEvent(new CustomEvent("merchant-permissions-changed", {
    detail: { permissions: payload.data.permissions || [] },
  }));
  return payload.data;
};

export const isMerchantAuthenticated = () => Boolean(localStorage.getItem(TOKEN_KEY));
export const getMerchantToken = () => localStorage.getItem(TOKEN_KEY);
export const getStoredMerchantStaff = () => {
  try {
    return JSON.parse(localStorage.getItem(STAFF_KEY) || "null");
  } catch {
    return null;
  }
};

export const isMerchantOwner = () => {
  const staff = getStoredMerchantStaff();
  return staff?.role === "owner" || (staff && !staff.merchant_id);
};
export const hasMerchantPermission = (permission) => {
  const staff = getStoredMerchantStaff();
  return isMerchantOwner() || (staff?.permissions || []).includes(permission);
};
export const updateStoredMerchantPermissions = (permissions) => {
  const staff = getStoredMerchantStaff();
  if (!staff || isMerchantOwner()) return;
  localStorage.setItem(STAFF_KEY, JSON.stringify({ ...staff, permissions }));
  window.dispatchEvent(new CustomEvent("merchant-permissions-changed", {
    detail: { permissions },
  }));
};
